<template>
  <f7-page name="specials">
    <bc-navbar></bc-navbar>
    <div class="layout_fullwidth_padding">
      <h2 class="page_title">SPECIALS</h2>
      <a class="back-link" href="inventory"><i class="fas fa-arrow-left icon"></i>back to full inventory</a>

      <div v-if='!isLoaded' class='loader-container' color="#f9f300">
        <loader :animation-duration="2500" :rhombus-size="25" color="#f9f300" />
      </div>

      <div v-else class="row">
        <div v-for="item in specials" :key="item.id" class="inventory-list-item">
          <InventoryListItem :backUrl="backUrl" :item="item" :borderStyle="borderStyle"/>
        </div>

        <div class='padging-container' v-if='specials.length === 0'>
          <span>NO RESULT</span>
        </div>
      </div>

    </div>
  </f7-page>
</template>

<script>
  import InventoryListItem from '@/components/inventory/inventory-list-item'
  import {
    LoopingRhombusesSpinner
  } from 'epic-spinners'
  import {
    mapActions,
    mapState,
    mapGetters
  } from 'vuex'

export default {
    components: {
      InventoryListItem,
      'loader': LoopingRhombusesSpinner
    },
    data () {
      return {
        isLoaded: false,
        backUrl: 'specials',
        filterData: {
          isUsed: true,
          sort: 'added_asc',
          size: 12,
          page: 1
        }
      }
    },
    async mounted () {
      await this.loadSpecials(this.filterData)
      this.isLoaded = true
    },
    computed: {
      ...mapState({
        customization: state => state.common.customization
      }),
      ...mapGetters({
        specials: 'inventory/getSpecials'
      }),
      borderStyle: function () {
        var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor : 'none'
        var backgroundStyle = this.customization.mainColor
        var colorStyle = this.customization.fontColor
        return {
          border: borderStyle,
          background: backgroundStyle,
          color: colorStyle
        }
      }
    },
    methods: {
      ...mapActions({
        loadSpecials: 'inventory/loadSpecials'
      })
    }
  }
</script>

<style>
  .inventory-list-item {
    margin-bottom: 20px;
    width: 100%;
  }

  .padging-container {
    text-align: center;
    padding: 25px;
  }

  .loader-container {
    flex: 1;
    text-align: center;
    padding-top: 15%;
  }

  .looping-rhombuses-spinner {
    display: inline-block;
  }

  .back-link{
    margin-bottom: 15px;
    display: inline-block;
  }
  .back-link>.icon{
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// specials.vue?aa29d134